import { DISPLAY_VARIANT_PRIMARY, DISPLAY_VARIANT_SECONDARY } from '../stamp/stamp.constants';

export const getDisplayVariant = incentive => {
  try {
    return incentive.display.variant.toLowerCase();
  } catch (error) {
    return '';
  }
};

export const hasValidDisplayVariant = incentive => {
  const variant = getDisplayVariant(incentive);

  return variant === DISPLAY_VARIANT_PRIMARY || variant === DISPLAY_VARIANT_SECONDARY;
};

export const getLinesCount = incentives => {
  if (!incentives || !incentives.length) {
    return false;
  }

  return incentives
    .filter(hasValidDisplayVariant)
    .reduce(
      (result, incentive) => result + (incentive.lines ? incentive.lines.filter(line => line.text).length : 0),
      0,
    );
};
